export * from './getCoachDescriptor'
export * from './getAbbreviatedCoachName'
